"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Notification = void 0;
var react_1 = __importDefault(require("react"));
var snackbar_1 = require("remota-client/component/snackbar");
exports.Notification = react_1.default.memo(function (props) {
    var useNotification = props.useNotification;
    var _a = __read(useNotification(), 2), get = _a[0], drop = _a[1];
    var message = get();
    if (!message) {
        return null;
    }
    return react_1.default.createElement(snackbar_1.Snackbar, { message: message, drop: drop });
});
